import axios from '../axios';

export const getChartsDateSubjectComparison = (data) => {
  return axios({
    url: '/console/education/data_compare_subject',
    method: 'GET',
    data,
  })
}

export const getSchoolList = (data) => {
  return axios({
    url: '/console/school/list_by_grade',
    method: 'GET',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/subjectComparison.js